<template>
    <div>
        <div class="row">
            <div class="col-sm-1">
                <div class="form-group">
                    <label class="label-control blue">{{$t('year')}}</label>
                    <div>
                        <select class="form-control form-control-sm" v-model="query.Year" @change="toList">
                            <option v-for="ret in $years()" :value="ret" :key="ret">{{ret}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-1">
                <div class="form-group">
                    <label class="label-control blue">{{$t('month')}}</label>
                    <div>
                        <select class="form-control form-control-sm" v-model="query.Month" @change="toList">
                            <option v-for="n in 12" :value="n" :key="n">{{$t('month_' + n)}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div class="form-group">
                    <label class="label-control blue">{{$t('item_name')}}</label>
                    <div>
                        <AuthCompleted @select="itemSelect($event)" :place="$t('all')"></AuthCompleted>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <table class="table table-bordered table-sm table-striped no-bor">
                    <thead>
                        <tr>
                            <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                            <th>{{$t('invoice_no')}}</th>
                            <th>{{$t('date')}}</th>
                            <th>{{$t('item_code')}}</th>
                            <th>{{$t('item_name')}}</th>
                            <th class="text-right">{{$t('qty')}}</th>
                            <th class="text-right">{{$t('price_sale')}}</th>
                            <th class="text-right">{{$t('cost')}}</th>
                            <th class="text-right">{{$t('total_sale_amount')}}</th>
                            <th class="text-right">{{$t('discount')}}</th>
                            <th class="text-right">{{$t('total_amount')}}</th>
                            <th class="text-right">{{$t('total_cost')}}</th>
                            <th class="text-right">{{$t('gross_profit')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ret.InvoiceNum}}</td>
                            <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                            <td>{{ret.ItemCode}}</td>
                            <td>{{ret.ItemName}}</td>
                            <td class="text-right">{{$number(ret.Quantity)}}</td>
                            <td class="text-right">{{$money(ret.Price)}}</td>
                            <td class="text-right">{{$money(ret.Cost)}}</td>
                            <td class="text-right">{{$money(ret.Quantity * ret.Price)}}</td>
                            <td class="text-right">{{$money(ret.Discount)}}</td>
                            <td class="text-right">{{$money(ret.SubTotal)}}</td>
                            <td class="text-right">{{$money(ret.TotalCost)}}</td>
                            <td class="text-right">{{$money(ret.SubTotal-ret.TotalCost)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="8" class="text-right">{{$t('total')}}</th>
                            <th class="text-right">{{$money(summary.GrandTotal)}}</th>
                            <th class="text-right">{{$money(summary.Discount)}}</th>
                            <th class="text-right">{{$money(summary.SubTotal)}}</th>
                            <th class="text-right">{{$money(summary.TotalCost)}}</th>
                            <th class="text-right">{{$money(summary.GrossProfit)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import AuthCompleted from '../../Item/Select.vue';
    export default {
        components: { AuthCompleted },
        data: function(){
            return {
                query:{
                    Year: new Date().getFullYear(),
                    Month: new Date().getMonth() + 1,
                    ItemId: ''
                },
                records:[],
                summary: {
                    GrandTotal: 0,
                    Discount: 0,
                    SubTotal: 0,
                    TotalCost: 0,
                    GrossProfit: 0
                }
            }
        },
        created: function(){
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                this.$api().post('report/sale/detail', this.query).then((res) => {
                    if(this.$isValid(res)){
                        this.records = res.data.Json.SaleLines;
                        this.calculate();
                        this.$emit('change', 3, this.query);
                    }
                }).finally(function() { loading.hide(); });
            },
            calculate(){
                let grand_total = 0;
                let discount = 0;
                let totalAmount = 0;
                let totalCost = 0;
                let gross_profit = 0;
                let balance = 0;
                this.records.map(el => {
                    grand_total += el.Quantity * el.Price;
                    discount += el.Discount;
                    totalAmount += el.SubTotal;
                    totalCost += el.TotalCost;
                    gross_profit += el.SubTotal - el.TotalCost;
                });
                this.summary.GrandTotal = grand_total;
                this.summary.Discount = discount;
                this.summary.SubTotal = totalAmount;
                this.summary.TotalCost = totalCost;
                this.summary.GrossProfit = gross_profit;
                this.summary.Balance = balance;
            },
            customerChange(e){
                if(e == null) this.query.CustomerId = '';
                else this.query.CustomerId = e.Id;
                this.toList();
            },
            itemSelect(sender){
                if(sender == null) this.query.ItemId = '';
                else this.query.ItemId = sender.Id;
                this.toList();
            }
        }
    }
</script>